import { logError } from '@tomra/datadog-browser-logging'
import { ampli } from '$lib/ampli'
import { AMPLITUDE_CONFIG } from './environment'

export function initAmplitude() {
  if (!ampli.isLoaded) {
    const disabled = !!window.location.host.match(/(:\d{4})/gi)

    const autocapture = disabled
      ? false
      : {
          pageViews: true,
          sessions: true,
          formInteractions: true,
          fileDownloads: false
        }

    try {
      ampli.load({
        disabled,
        client: {
          apiKey: AMPLITUDE_CONFIG.apiKey,
          configuration: {
            autocapture,
            logLevel: 0
          }
        }
      })
    } catch (error: unknown) {
      logError(new Error('Unable to load Amplitude'), error as Error)
    }
  }
}
